module.exports = __webpack_public_path__ + "img/homepage-balloon-flags.ba63932.svg";